export default {
  lastOperation: (state) => {
    return state.lastOperation;
  },
};
